import Vue from 'vue'
import axios from 'axios';
import _ from 'lodash';

export const STATUS_NEW = 10;
export const STATUS_READ = 20;

export default {
    state: {
        options: [],
    },
    mutations: {
        fetchOptions(state, payload) {
            state.options = payload;
        },
        setOptions(state, payload) {
            state.options = payload;
        },
        editOption(state, payload) {
            const index = state.options.findIndex(item => item.okey === payload.okey);
            Vue.set(state.options, index, payload);
        },
        addOption(state, payload) {
            state.options.unshift(payload);
        },
    },

    actions: {
        async fetchOptions({ commit, dispatch }) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/option`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchOptions', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if(errors.status == 401){
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async editOption({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/option/${payload.okey}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editOption', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
    },

    getters: {
        options (state) {
            return state.options
        },
    }
}